import React, { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import InputStylefield from "../../../assets/InputStyle";

const Deactvation = ({ openDialog, setOpenDialog }) => {
    const [addDeactivation, setAddDeactivation] = useState(false);
    const [pending, setPending] = useState("");
    const [error, setError] = useState(false);
    const [completeDeactivate, setCompleteDeactivate] = useState(false);

    const closeHandler = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setAddDeactivation(false)
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    }

    const closeErrorModal = () => {
        setError(false);
    }


    const openErrorModal = () => {
        setError(true);
    }



    const closeCompleteModal = () => {
        setCompleteDeactivate(false);
    }


    const openCompleteModal = () => {
        setCompleteDeactivate(true);
        setError(false);
    }

    return (
        <>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>

                    <CloseIcon sx={{
                        float: 'right',
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        borderRadius: '50%',
                        border: '1px solid #000',
                        padding: '4px',
                    }} onClick={handleCloseDialog} />
                </DialogTitle>

                <DialogContent sx={{ textAlign: 'center' }}>
                    <Typography className="text1Bold" >Do you want to deactivate your account? </Typography>

                </DialogContent>

                <DialogActions sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#2544EE',
                }}>
                    <Button
                        className="text2Bold"
                        variant="contained"
                        sx={{
                            backgroundColor: '#2544EE',
                            border: '1px solid #fff',
                            boxShadow: 'none',
                            px: 2,
                            '&:hover': {
                                backgroundColor: '#FFF',
                                color: '#2544EE',
                                boxShadow: 'none',

                            },
                        }}
                    >
                        No
                    </Button>

                    <Button
                        className="text2Bold "
                        variant="contained"
                        sx={{
                            backgroundColor: '#FFF',
                            color: '#2544EE',
                            boxShadow: 'none',
                            px: 2,
                            '&:hover': {
                                backgroundColor: '#2544EE',
                                color: '#FFF',
                                boxShadow: 'none',

                            },
                        }}
                        onClick={openErrorModal}
                    >
                        Yes
                    </Button>

                </DialogActions>
            </Dialog>

            {/* Error Modal */}
            <Dialog
                open={error}
                onClose={closeErrorModal}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>

                    <CloseIcon sx={{
                        float: 'right',
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        borderRadius: '50%',
                        border: '1px solid #000',
                        padding: '4px',
                    }} onClick={closeErrorModal} />
                </DialogTitle>

                <DialogContent sx={{ textAlign: 'center' }}>
                    <Typography className="text1Bold" >There are pending transaction that need to be Cleared first </Typography>
                </DialogContent>

                <DialogActions sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#ff0000',
                }}>


                    <Button
                        className="text2Bold "
                        variant="contained"
                        sx={{
                            backgroundColor: '#FFF',
                            color: '#000',
                            boxShadow: 'none',
                            px: 2,
                            '&:hover': {
                                backgroundColor: '#2544EE',
                                color: '#000',
                                boxShadow: 'none',

                            },
                        }}
                        onClick={openCompleteModal}
                    >
                        OK
                    </Button>

                </DialogActions>
            </Dialog>

              {/* Complete Modal */}
              <Dialog
                open={completeDeactivate}
                onClose={closeCompleteModal}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>

                    <CloseIcon sx={{
                        float: 'right',
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        borderRadius: '50%',
                        border: '1px solid #000',
                        padding: '4px',
                    }} onClick={closeCompleteModal} />
                </DialogTitle>

                <DialogContent sx={{ textAlign: 'center' }}>
                    <Typography className="text1Bold" >Your account is get deactivate. </Typography>
                </DialogContent>

                <DialogActions sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#2544EE',
                }}>


                    <Button
                        className="text2Bold "
                        variant="contained"
                        sx={{
                            backgroundColor: '#FFF',
                            color: '#000',
                            boxShadow: 'none',
                            px: 2,
                            '&:hover': {
                                backgroundColor: '#fff',
                                color: '#000',
                                boxShadow: 'none',

                            },
                        }}
                    >
                        OK
                    </Button>

                </DialogActions>
            </Dialog>
        </>
    )
}

export default Deactvation;